import {observer} from 'mobx-react';
import React from 'react';
import {ClassroomRoleSelect} from '../../../../lib/components';
import {X9ContentViewStore} from './X9ContentViewStore';

@observer
export class X9ContentViewHeaders extends React.Component<{ store: X9ContentViewStore }> {
  render() {
    const store = this.props.store;

    return (
      <div className="row justify-content-end">
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  onClick={store.resetState}>
            Reset
          </button>
        </div>
        <div className="col-auto">
          <ClassroomRoleSelect value={store.role.value}
                               onChange={store.role.setValue}/>
        </div>
      </div>
    );
  }
}
